import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueCompositionApi from "@vue/composition-api";

import ElementUI from "element-ui";

const elementUiLocale = require("element-ui/lib/locale/lang/pl").default;

import "@/components/globals";

Vue.use(ElementUI, { locale: elementUiLocale });

Vue.use(VueCompositionApi);

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
